(() => {
  const requestedArtwork = new URLSearchParams(window.location.search).get("obra");
  const contactMessage = document.getElementById("LesterMessage");
  if (requestedArtwork && contactMessage && !contactMessage.value) {
    contactMessage.value = `Hola, me gustaría recibir información sobre la obra «${requestedArtwork.slice(0, 200)}».`;
  }
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      const menu = document.querySelector(".lj-menu[open]");
      if (menu) { menu.open = false; menu.querySelector("summary").focus(); }
    }
  });
  const closeDialog = (dialog) => dialog.close();
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-lj-dialog]");
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.ljDialog);
      if (dialog) {
        dialog.showModal();
        dialog.dataset.triggerId = trigger.id || "";
      }
    }
    const close = event.target.closest("[data-lj-close]");
    if (close) closeDialog(close.closest("dialog"));
    const inquiry = event.target.closest("[data-lj-inquiry]");
    if (inquiry) {
      const field = document.getElementById("LesterMessage");
      if (field)
        field.value = `Hola, me gustaría recibir información sobre ${inquiry.dataset.ljInquiry}.`;
      const dialog = inquiry.closest("dialog");
      if (dialog) closeDialog(dialog);
    }
    if (event.target instanceof HTMLDialogElement) {
      const box = event.target.getBoundingClientRect();
      if (
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom
      )
        closeDialog(event.target);
    }
    const menu = document.querySelector(".lj-menu");
    if (
      menu?.open &&
      (!menu.contains(event.target) ||
        event.target.closest(".lj-menu__panel a"))
    )
      menu.open = false;
  });
})();

// Match desktop thumbnails to the visible image, including portrait artwork.
(() => {
  const setup = (root = document) => {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.ljWidthReady) return;
      gallery.dataset.ljWidthReady = 'true';
      const update = () => {
        const image = gallery.querySelector('.product__media-item.is-active .product__media img');
        if (!image || !image.naturalWidth) return;
        const box = image.getBoundingClientRect();
        const width = Math.min(box.width, box.height * image.naturalWidth / image.naturalHeight);
        gallery.style.setProperty('--lj-artwork-width', `${width}px`);
      };
      new ResizeObserver(update).observe(gallery);
      new MutationObserver(update).observe(gallery, {subtree: true, attributes: true, attributeFilter: ['class', 'src']});
      gallery.addEventListener('load', update, true);
      update();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

// Keep equal badge insets from the artwork itself, including contain-fit images.
if (!customElements.get('lester-sold-out')) {
  customElements.define('lester-sold-out', class extends HTMLElement {
    connectedCallback() {
      this.link = this.parentElement;
      this.image = this.link.querySelector('img');
      if (!this.image) return;
      this.update = () => {
        if (!this.image.naturalWidth) return;
        const imageBox = this.image.getBoundingClientRect();
        const linkBox = this.link.getBoundingClientRect();
        const scale = Math.min(imageBox.width / this.image.naturalWidth, imageBox.height / this.image.naturalHeight);
        const width = this.image.naturalWidth * scale;
        const height = this.image.naturalHeight * scale;
        this.style.setProperty('--lj-badge-top', `${imageBox.top - linkBox.top + (imageBox.height - height) / 2 + 12}px`);
        this.style.setProperty('--lj-badge-right', `${linkBox.right - imageBox.right + (imageBox.width - width) / 2 + 12}px`);
      };
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.link);
      this.observer.observe(this.image);
      this.image.addEventListener('load', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.image?.removeEventListener('load', this.update);
    }
  });
}
